<script lang="ts">
	// ? Should we use something like DOMPurify to sanitize schema or other html content ?
	import { serializeStructuredSchema, type StructuredSchema } from './serializeSchema';

	interface Props {
		schema: StructuredSchema;
	}

	const { schema }: Props = $props();
</script>

{#if schema}
	<!-- eslint-disable-next-line svelte/no-at-html-tags -->
	{@html serializeStructuredSchema(schema)}
{/if}
